/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'gh-manager-tab-container',
  templateUrl: 'manager-tab-container.component.html',
})
export class ManagerTabContainerComponent {
}
